import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Card, Col, Row } from 'react-bootstrap';
import CardDropdown from 'components/common/CardDropdown';
import Flex from 'components/common/Flex';
import AverageEnrollmentChart from './AverageEnrollmentChart';
import { useEffect } from 'react';
import { useState } from 'react';
import moment from 'moment';

const SupportServicesLineCategory = ({data}) => {


useEffect(()=>{
const xAxiasData=[];
const yAxiasData=[];
for(let i=0;i<data.length;i++){

  xAxiasData.push(data[i].date)
  yAxiasData.push(data[i].totalSupportCalls)
}
setChartData({...chartData,xAxisData:xAxiasData,totalSupportCalls:yAxiasData})

},[data])
  const [chartData,setChartData] = useState({
    totalSupportCalls: [
    //   2000, 2800, 2200, 3001, 600, 600, 2000, 2000, 700, 1000, 200, 900, 1200,2000, 2800, 2200, 3001, 600, 600, 2000, 2000, 700
    ],
   seriesName: 'Total Support Calls',
   xAxisData:[
    // '1', // Start from 1 instead of 'launch'
    // '2', // 2 instead of 'week 1'
    // '3', // 3 instead of 'week 2'
    // '4', // 4 instead of 'week 3'
    // '5', // 5 instead of 'week 4'
    // '6', // 6 instead of 'week 5'
    // '7', // 7 instead of 'week 6'
    // '8', // 8 instead of 'week 7'
    // '9', // 9 instead of 'week 8'
    // '10', // 10 instead of 'week 9'
    // '11', // 11 instead of 'week 10'
    // '12', // 12 instead of 'week 11'
    // '13', // 13 instead of 'week 12'
    // '14', // 14
    // '15', // 15
    // '16', // 16
    // '17', // 17
    // '18', // 18
    // '19', // 19
    // '20', // 20
    // '21', // 21
    // '22'  // 22
  ],
  });

  const chartRef = useRef(null);

  const handleLegendToggle = (event, name) => {
    chartRef.current.getEchartsInstance().dispatchAction({
      type: 'legendToggleSelect',
      name
    });
    event.target.closest('button').classList.toggle('opacity-50');
  };

  return (
    <Card>
      <Card.Header>
        <Row className="flex-between-center g-0">
          <Col xs="auto">
            {/* <h5 className="mb-0">Support Services - Date | 2023 Jan 01 - 2023 Jan 22</h5> */}
          </Col>
          <Col md="auto" className="order-1 order-md-0">
            <Flex className="flex-wrap gap-md-2">
              <Button
                variant="text"
                size="sm"
                className="d-flex align-items-center p-0 shadow-none"
                onClick={event => handleLegendToggle(event, 'Support Calls')}
              >
                <FontAwesomeIcon
                  icon="circle"
                  className="text-warning fs--2 me-1"
                  transform="shrink-3"
                />
                <small className="text-600">Support Calls</small>
              </Button>
        
            </Flex>
          </Col>
          <Col xs="auto">
            <CardDropdown />
          </Col>
        </Row>
      </Card.Header>
      <Card.Body className="pb-0">
        <AverageEnrollmentChart
        data={chartData}
          ref={chartRef}
          style={{ 'min-height': '18.625rem', width: '100%' }}
        />
      </Card.Body>
    </Card>
  );
};


export default SupportServicesLineCategory;
